/**
 * Supported UI languages (ES and EN). Used by Settings page and language switch.
 */
export const LANGUAGES = [
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

export function normalizeLanguageCode(lng) {
  if (!lng || typeof lng !== 'string') return 'es';
  const base = lng.split('-')[0].toLowerCase();
  return base === 'en' ? 'en' : 'es';
}
